var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7644 0.0335487C11.5856 -0.0111829 11.407 -0.0111829 11.2282 0.0335487L1.89014 2.98247L11.4963 6.51228L21.1025 3.0272L11.7644 0.0335487Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.99617 15.5825C0.99617 15.9399 1.21952 16.2975 1.57707 16.3868L10.6027 19.6931V8.03147L0.996094 4.54639L0.99617 15.5825Z",
    fill: "#6DBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3896 8.03139V15.895C13.1046 14.0185 14.8917 12.6333 17.0363 12.6333C19.2703 12.6333 21.1468 14.1078 21.7726 16.1631C21.9066 16.0291 21.9959 15.8057 21.9959 15.5822L21.9961 4.54639L12.3896 8.03139Z",
    fill: "#6DBFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0369 14.7778C15.4731 14.7778 14.1772 16.0735 14.1772 17.6374C14.1772 17.9948 14.2666 18.3524 14.356 18.665C14.7581 19.7374 15.7857 20.4523 16.9921 20.4523C18.5559 20.4523 19.8517 19.1566 19.8517 17.5927C19.8517 17.3246 19.807 17.1013 19.7624 16.8778C19.4496 15.6714 18.3325 14.7778 17.0369 14.7778ZM17.9304 17.9501L18.1538 18.1735C18.3325 18.3522 18.3325 18.5756 18.1538 18.7544C17.975 18.9331 17.7516 18.9331 17.5729 18.7544L17.3495 18.531C17.1707 18.3522 16.9474 18.3522 16.7686 18.531L16.5005 18.7991C16.3218 18.9779 16.0984 18.9779 15.9196 18.7991L15.8751 18.7098C15.6963 18.531 15.6963 18.3076 15.8751 18.1289L16.1431 17.8608C16.3219 17.682 16.3219 17.4587 16.1431 17.2799L15.9198 17.0565C15.741 16.8778 15.741 16.6544 15.9198 16.4756C16.0986 16.2969 16.3219 16.2969 16.5007 16.4756L16.724 16.699C16.9028 16.8778 17.1262 16.8778 17.3049 16.699L17.573 16.4309C17.7518 16.2521 17.9751 16.2521 18.1539 16.4309L18.2432 16.5202C18.422 16.699 18.422 16.9223 18.2432 17.1011L17.9304 17.3694C17.7516 17.548 17.7516 17.7715 17.9304 17.9501Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejects);
export default __webpack_public_path__ + "static/media/rejects.4d3096c6c4028e8d38389677662560d9.svg";
export { ForwardRef as ReactComponent };